
import axios from 'axios'

const ProofGroup = {

    async getAll(collectionId){
        const options = {
            url: `${window.ProveAnything.config.functionPath}/collection/${collectionId}/proofGroup`,
            baseURL: window.ProveAnything.config.functionUrl,
            method: "get",
            headers: {
              "Content-Type": "application/json"
            },
            responseType: "json",
          };
      
          try {
            const response = await axios(options);
            const json = response.data;
      
            return json;
          } catch (error) {
            return error
          }
    },


    async get(collectionId, proofGroupId){

        const options = {
            url: `${window.ProveAnything.config.functionPath}/collection/${collectionId}/proofGroup/${proofGroupId}`,
            baseURL: window.ProveAnything.config.functionUrl,
            method: "get",
            headers: {
              "Content-Type": "application/json"
            },
            responseType: "json",
          };
      
          try {
            const response = await axios(options);
            const json = response.data;
      
            return json;
          } catch (error) {
            return error
          }
    },   

    async createClaim(collectionId, proofGroupId, params){

      const options = {
          url: `${window.ProveAnything.config.functionPath}/collection/${collectionId}/proofGroup/${proofGroupId}/createClaim`,
          baseURL: window.ProveAnything.config.functionUrl,
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          data: JSON.stringify(params),
          responseType: "json",
        };
    
        try {
          const response = await axios(options);
          const json = response.data;
    
          return json;
        } catch (error) {
          return error.response
        }
    },       

  }




const Accesslist = {
  
  async getProof(site, proofGroupId, type, address){

    // validate the merkle proof
    const options = {
      url: `/action/nft/accesslist/${site}/${proofGroupId}/validateAddress/${type}/${address}`,
      baseURL: window.ProveAnything.config.functionUrl,
      method: "get",
      headers: {
        "Content-Type": "application/json"
      },
      responseType: "json",
    };

    try {
      const response = await axios(options);
      const json = response.data;

      return json;
    } catch (error) {
      return error.response
    }
    
 //   return data

  },
}
ProofGroup.Accesslist = Accesslist

export default ProofGroup;
 